namespace Nobox.Administration {
    export interface UserListRequest extends Serenity.ListRequest {
        Menu?: string;
        Online?: string;
        SDateAgentComparison?: string;
        EDateAgentComparison?: string;
    }
}
